import { render } from "./sso-callback.vue?vue&type=template&id=892e33d6&ts=true"
import script from "./sso-callback.vue?vue&type=script&lang=ts"
export * from "./sso-callback.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__